module.exports = __webpack_public_path__ + "static/media/Puzzle_bg.93a395b2.jpg";